import { render, staticRenderFns } from "./graphs.vue?vue&type=template&id=7088bd4c&scoped=true&"
import script from "./graphs.vue?vue&type=script&lang=ts&"
export * from "./graphs.vue?vue&type=script&lang=ts&"
import style0 from "./graphs.vue?vue&type=style&index=0&id=7088bd4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7088bd4c",
  null
  
)

component.options.__file = "graphs.vue"
export default component.exports